// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".playkit-more-icon_fR{margin-right:0;z-index:2}", "",{"version":3,"sources":["webpack://./src/services/upper-bar-manager/ui/more-icon/more-icon.component.scss"],"names":[],"mappings":"AAAA,sBAAW,cAAc,CAAC,SAAS","sourcesContent":[".more-icon{margin-right:0;z-index:2}"],"sourceRoot":""}]);
// Exports
export var moreIcon = "playkit-more-icon_fR";
export default ___CSS_LOADER_EXPORT___;
